import { actions as flurryActions } from 'Slice/HelperSlice';
import { valueToObject } from 'Utils/UtilityFunctions';
import {
  primaryColor, primaryFont, wLight, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 8px;
  .disclaimer-area-v3 {
    .disclaimer-text-v3 {
      font-family: ${primaryFont};
      font-weight: ${wLight};
      font-size: 10px;
      line-height: 6px;
      letter-spacing: -0.311px;
      margin-bottom: 0;
      color: #979797;
    }
  }
  .primary-color {
    cursor: pointer;
    color: ${primaryColor} !important;
    font-weight: ${wMedium};
  }
`;

const DisclaimerCmpFooterV3 = function DisclaimerCmpFooterV3() {
  const disclaimerMessageOne = '- Possibility of information that may not be entirely accurate.';
  const disclaimerMessageTwo = '- Might have incomplete information on the product or service.Please contact at';
  const dispatch = useDispatch();
  const host = window.location.href;

  const handleClick = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('xcgpt_footer_email_clicked', 0, host),
    ));
  };

  return (
    <StyledWrapper className="disclaimer-footer">
      <div className="disclaimer-area-v3">
        <p className="disclaimer-text-v3">{disclaimerMessageOne}</p>
        <span className="disclaimer-text-v3">
          {disclaimerMessageTwo}
          {' '}
          <a onClick={handleClick} href="mailto:gilroy@xiqinc.com" className="disclaimer-text-v3 primary-color">gilroy@xiqinc.com</a>
        </span>
      </div>
    </StyledWrapper>
  );
};

export default DisclaimerCmpFooterV3;
